// src/components/insurance/InsurancePage.jsx
import React from 'react';
import { Shield, Check, Clock, Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import InsuranceForm from './InsuranceForm';

const InsurancePage = () => {
  const { t } = useLanguage();

  // Benefits content
  const benefits = [
    {
      icon: Shield,
      title: 'completeProtection',
      description: 'completeProtectionDesc'
    },
    {
      icon: Check,
      title: 'easyApplication',
      description: 'easyApplicationDesc'
    },
    {
      icon: Clock,
      title: 'quickProcessing',
      description: 'quickProcessingDesc'
    },
    {
      icon: Globe,
      title: 'georgiaWideAcceptance',
      description: 'georgiaWideAcceptanceDesc'
    }
  ];

  // FAQ content
  const faqs = [
    {
      question: 'faqCoverage',
      answer: 'faqCoverageAnswer'
    },
    {
      question: 'faqDocuments',
      answer: 'faqDocumentsAnswer'
    },
    {
      question: 'faqDuration',
      answer: 'faqDurationAnswer'
    },
    {
      question: 'faqProcessing',
      answer: 'faqProcessingAnswer'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-3xl font-extrabold text-neutral-900 sm:text-4xl">
          {t('vehicleInsuranceForGeorgia')}
        </h1>
        <p className="mt-4 text-lg text-neutral-600 max-w-3xl mx-auto">
          {t('insurancePageSubtitle')}
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Main Content - Insurance Form */}
        <div className="lg:col-span-2">
          <InsuranceForm />
        </div>

        {/* Sidebar - Benefits */}
        <div className="space-y-8">
          {/* Benefits Section */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-4 bg-primary-800 text-white">
              <h3 className="font-bold text-lg">{t('benefits')}</h3>
            </div>
            <div className="p-5 space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary-100 text-primary-600">
                      <benefit.icon className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-base font-medium text-neutral-900">
                      {t(benefit.title)}
                    </h4>
                    <p className="mt-1 text-sm text-neutral-600">
                      {t(benefit.description)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* FAQ Section */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-4 bg-primary-800 text-white">
              <h3 className="font-bold text-lg">{t('faq')}</h3>
            </div>
            <div className="p-5">
              <dl className="space-y-6">
                {faqs.map((faq, index) => (
                  <div key={index}>
                    <dt className="text-base font-medium text-neutral-900">
                      {t(faq.question)}
                    </dt>
                    <dd className="mt-2 text-sm text-neutral-600">
                      {t(faq.answer)}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsurancePage;